import React from "react";
import {withGoogleMap, GoogleMap, Marker, Polyline} from "react-google-maps/lib";
import mapStyle from "../shipment/mapStyle";

const MapComponent = withGoogleMap((props, idx) => (
  <GoogleMap
    ref={props.onMapLoad}
    defaultZoom={3}
    defaultCenter={{lat: 40.416775, lng: -3.703790}}
    onClick={props.onMapClick}
    defaultOptions={{ styles: mapStyle }}>

    {props.markers.map((marker, key) => (
      <Marker
        {...marker}
        key = {key}
        icon = "../../public/images/icons_png/location_pin.png"
        onRightClick={() => props.onMarkerRightClick(marker)}
      />
    ))}
  </GoogleMap>
));

export default class ContactMap extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      markers: [
        {
          position: {
            lat: 40.416775,
            lng: -3.703790,
          },
          defaultAnimation: 2
        }
      ]
    };

    this.handleMapLoad = this.handleMapLoad.bind(this);
    this.handleMarkerRightClick = this.handleMarkerRightClick.bind(this);
  }

  handleMapLoad(map) {
    this._mapComponent = map;
    if (map) {

    }
  }

  handleMarkerRightClick(targetMarker) {
    /*
     * All you modify is data, and the view is driven by data.
     * This is so called data-driven-development. (And yes, it's now in
     * web front end and even with google maps API.)
     */
    const nextMarkers = this.state.markers.filter(marker => marker !== targetMarker);
    this.setState({
      markers: nextMarkers,
    });
  }

  render() {
    const {state,props} = this;
    let coords =  { lat: 40.416775, lng: -3.703790 };

    return (
      <div style={{height: `400px`}}>
        <MapComponent
          containerElement={<div style={{ height: `400px` }} />}
          mapElement={<div style={{ height: `400px` }} />}
          onMapLoad={this.handleMapLoad}
          onMapClick={this.handleMapClick}
          markers={state.markers}
          onMarkerRightClick={this.handleMarkerRightClick}
          coords = {coords}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// app/static_pages/contact_map.jsx